var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack229({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.43,9.73l1.69-.17a2,2,0,0,0,.62,1.25,1.84,1.84,0,0,0,1.25.4,1.94,1.94,0,0,0,1.27-.36A1,1,0,0,0,9.68,10a.77.77,0,0,0-.18-.52,1.29,1.29,0,0,0-.62-.37c-.2-.08-.67-.2-1.39-.38a4.7,4.7,0,0,1-2-.85,2.26,2.26,0,0,1-.79-1.73A2.3,2.3,0,0,1,5.11,5a2.35,2.35,0,0,1,1.08-.87,4.45,4.45,0,0,1,1.69-.29,3.61,3.61,0,0,1,2.43.7,2.52,2.52,0,0,1,.86,1.9l-1.73.07a1.51,1.51,0,0,0-.48-1,1.78,1.78,0,0,0-1.1-.29,2,2,0,0,0-1.18.31.61.61,0,0,0-.28.53.68.68,0,0,0,.26.53,4.69,4.69,0,0,0,1.59.57,8.37,8.37,0,0,1,1.87.62,2.35,2.35,0,0,1,1,.87A2.68,2.68,0,0,1,11,11.4a2.5,2.5,0,0,1-1.16,1A4.88,4.88,0,0,1,8,12.67a3.76,3.76,0,0,1-2.51-.75A3.25,3.25,0,0,1,4.43,9.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack229);
export default __webpack_public_path__ + "static/media/Symbolpack_2_29.fad35efeeb049049fbff1e9875a4ef7a.svg";
export { ForwardRef as ReactComponent };